import React from 'react';
import { type ConnectionLineComponentProps } from '@xyflow/react';
import { ARROW_MARKER_STYLES, LINK_STYLES } from './skillTreeStyles';

/** Temporary line shown while dragging from a link handle to create a new connection. */
export const SkillConnectionLine: React.FC<ConnectionLineComponentProps> = ({ fromX, fromY, toX, toY }) => {
    const midY = (fromY + toY) / 2;
    // Stop short of the cursor like the edge path does, so the marker's tip lands on it
    const endY = toY - Math.sign(toY - fromY || 1) * ARROW_MARKER_STYLES.tipLength;
    return (
        <path
            className="temp-link"
            d={`M${fromX},${fromY}C${fromX},${midY} ${toX},${midY} ${toX},${endY}`}
            fill="none"
            stroke={LINK_STYLES.colors.tempStroke}
            strokeWidth={LINK_STYLES.strokeWidths.tempStroke}
            markerEnd={`url(#${ARROW_MARKER_STYLES.id})`}
            style={{ pointerEvents: 'none' }}
        />
    );
};
